import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, tap, throwError } from 'rxjs';
import {
  CreateTransactionDetailParams,
  DeleteTransactionDetailByIdResponse,
  GetTransactionDetailByIdResponse,
  GetTransactionDetailRequestParams,
  GetTransactionDetailResponse,
  UpdateTransactionDetailRequestParams,
} from '../../pages/transactionDetails/transactionDetails.interface';
import { environment } from '../../../environments/environment';
import { toQueryString } from '../../shared/helpers/helpers';

@Injectable({
  providedIn: 'root',
})
export class TransactionDetailsService {
  private apiUrl = environment.api + '/transaction-details';

  constructor(private http: HttpClient) {}

  private handleResponse<T>(response: T & { code: number; message?: string }): T {
    if (response.code !== 0) {
      throw new Error(response.message);
    }
    return response;
  }

  private handleError(error: any): Observable<never> {
    console.error('API Error:', error);
    return throwError(() => new Error(error.error?.message || 'Error'));
  }

  getTransactionDetailService(requestParams: GetTransactionDetailRequestParams): Observable<GetTransactionDetailResponse> {
    const url = this.apiUrl + '?' + toQueryString(requestParams);
    return this.http.get<GetTransactionDetailResponse>(url).pipe(
      tap((response) => this.handleResponse(response)), // ✅ Pakai arrow function
      catchError((error) => this.handleError(error)) // ✅ Pakai arrow function
    );
  }

  getTransactionDetailById(id: string): Observable<GetTransactionDetailByIdResponse> {
    return this.http.get<GetTransactionDetailByIdResponse>(`${this.apiUrl}/${id}`).pipe(
      tap((response) => this.handleResponse(response)),
      catchError((error) => this.handleError(error))
    );
  }

  deleteTransactionDetailById(id: string): Observable<DeleteTransactionDetailByIdResponse> {
    return this.http.delete<DeleteTransactionDetailByIdResponse>(`${this.apiUrl}/${id}`).pipe(
      tap((response) => this.handleResponse(response)),
      catchError((error) => this.handleError(error))
    );
  }

  createTransactionDetail(transactionData: CreateTransactionDetailParams): Observable<GetTransactionDetailByIdResponse> {
    return this.http.post<GetTransactionDetailByIdResponse>(this.apiUrl, transactionData).pipe(
      tap((response) => this.handleResponse(response)),
      catchError((error) => this.handleError(error))
    );
  }

  updateTransactionDetail(id: string, transactionData: UpdateTransactionDetailRequestParams): Observable<GetTransactionDetailByIdResponse> {
    return this.http.put<GetTransactionDetailByIdResponse>(`${this.apiUrl}/${id}`, transactionData).pipe(
      tap((response) => this.handleResponse(response)),
      catchError((error) => this.handleError(error))
    );
  }
}
